import type { EventoDetalhe, EventoStats, PagamentosPorMetodo, ParticipanteEvento } from './types'

export function formatDate(dateString: string, withTime = false): string {
  const date = new Date(dateString)

  const base = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(date)

  if (!withTime) {
    return base
  }

  const time = new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)

  return `${base} às ${time}`
}

export function formatTime(dateString: string): string {
  return new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(dateString))
}

export function getParticipantLabel(label?: string) {
  return label ?? ''
}

export function calcularEstatisticas(
  participantes: ParticipanteEvento[],
  evento: EventoDetalhe | null
): EventoStats {
  const total = participantes.length
  const confirmados = participantes.filter((p) => p.status === 'confirmado').length
  const pendentes = participantes.filter((p) => p.status === 'pendente').length
  const cancelados = participantes.filter((p) => p.status === 'cancelado').length

  const receitaPrevista = participantes.reduce(
    (acc, participante) => acc + participante.pagamento.valor,
    0
  )
  const receitaRecebida = participantes
    .filter((p) => p.pagamento.status === 'pago')
    .reduce((acc, participante) => acc + participante.pagamento.valor, 0)
  const receitaPendente = receitaPrevista - receitaRecebida

  const ocupacao =
    evento?.capacidade && evento.capacidade > 0
      ? Math.min(100, Math.round((confirmados / evento.capacidade) * 100))
      : null

  return {
    total,
    confirmados,
    pendentes,
    cancelados,
    receitaPrevista,
    receitaRecebida,
    receitaPendente,
    ocupacao,
    taxaConfirmacao: total ? Math.round((confirmados / total) * 100) : 0,
  }
}

export function calcularPagamentosPorMetodo(
  participantes: ParticipanteEvento[]
): PagamentosPorMetodo {
  return participantes.reduce<PagamentosPorMetodo>((acc, participante) => {
    const { pagamento } = participante
    if (pagamento.status !== 'pago' || !pagamento.metodo) {
      return acc
    }
    const metodo = pagamento.metodo
    if (!acc[metodo]) {
      acc[metodo] = { quantidade: 0, total: 0 }
    }
    acc[metodo].quantidade += 1
    acc[metodo].total += pagamento.valor
    return acc
  }, {})
}
